import { useCallback, useState } from "react";

import { add } from "date-fns";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";

import { LOGIN_TIME, SESSION_HOURS, SESSION_TIME } from "../constants";

export const addHoursToDate = (dateString: string, hoursToAdd: number) => {
  const date = add(new Date(dateString), { hours: hoursToAdd });

  return date.toISOString();
};

export default function useLoginTime() {
  const [loginTime, _setLoginTime] = useState<Date | undefined>(
    window.localStorage.getItem(LOGIN_TIME)
      ? utcToZonedTime(
          window.localStorage.getItem(LOGIN_TIME) || "",
          Intl.DateTimeFormat().resolvedOptions().timeZone
        )
      : undefined
  );

  const setLoginTime = useCallback(() => {
    const now = zonedTimeToUtc(new Date(), Intl.DateTimeFormat().resolvedOptions().timeZone);
    const addedHours = addHoursToDate(now.toISOString(), SESSION_HOURS);

    window.localStorage.setItem(LOGIN_TIME, now.toISOString());
    window.localStorage.setItem(SESSION_TIME, addedHours);

    _setLoginTime(now);
  }, []);

  return [loginTime, setLoginTime] as const;
}
